import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_EN.json';
import exercises from './FITNESS_EXERCISES_EN.json';
import recipes from './FITNESS_RECIPES_EN.json';

export const FITNESS_DATA_EN: ServiceData = {
  articles,
  exercises,
  recipes,
};
